"use client";
import { USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { addEventToTracking } from "@website/tracking/user";
import { deepCompare } from "@website/utils/deep-compare";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import { useWelcomeScreen } from "@website/widget/login/utils/useWelcomeScreen";
import { memo, useEffect, useState } from "react";

export const Component = () => {
  const { isWelcomeScreen } = useWelcomeScreen();
  const router = useCompatRouter();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    if (isWelcomeScreen) {
      addEventToTracking(USER_TRACKING_EVENTS.APP_WELCOME_SCREEN_SHOWED, {
        product: "core"
      });
      router?.push(router?.pathname, {
        ...router?.query,
        login_step: "phone-number",
        login_modal: "login"
      });
    }
  }, [isWelcomeScreen, mounted]);
  return null;
};
export const WelcomeScreenClientHandler = memo(Component, deepCompare);
